"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Tracking = require("pricing-pages-unified-ui/constants/Tracking");

var _PurchaseMotionButton = _interopRequireDefault(require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SkeletonLoadWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("pricing-pages-unified-ui/utils/classNames"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  &.mon307purple {\n    background-color: ", " !important;\n    border-color: ", " !important;\n\n    &:hover {\n      background-color: #6977d1 !important;\n      border-color: #6977d1 !important;\n    }\n\n    &:active {\n      background-color: #5661a8 !important;\n      border-color: #5661a8 !important;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledPurchaseMotionButton = (0, _styledComponents.default)(_PurchaseMotionButton.default).withConfig({
  displayName: "Mon307TalkToSalesAuthedCta__StyledPurchaseMotionButton",
  componentId: "sc-1cmydvs-0"
})(_templateObject(), _colors.THUNDERDOME_DARK, _colors.THUNDERDOME_DARK);

var Mon307TalkToSalesAuthedCta = function Mon307TalkToSalesAuthedCta(_ref) {
  var hub = _ref.hub,
      location = _ref.location,
      _ref$isPurple = _ref.isPurple,
      isPurple = _ref$isPurple === void 0 ? false : _ref$isPurple,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["hub", "location", "isPurple", "className"]);
  var upgradeProduct = _HubMap.default[hub].upgradeProduct;
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  var purchaseMotionType = (0, _reactRedux.useSelector)(function (state) {
    return (0, _ExperimentTreatmentSelectors.mon307TtsPurchaseMotionType)(state, hub);
  });
  return _react.default.createElement(_SkeletonLoadWrapper.default, {
    height: 40,
    width: 127,
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(StyledPurchaseMotionButton, (0, _extends2.default)({
    purchaseMotions: [purchaseMotionType],
    level: 1,
    upgradeData: {
      app: _Tracking.APP,
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      uniqueId: location + "-" + upgradeProduct,
      upgradeProduct: upgradeProduct
    },
    className: (0, _classNames.default)(isPurple && 'mon307purple', className),
    "data-selenium-id": location + "-" + hub + "-" + purchaseMotionType + "-button"
  }, rest)));
};

Mon307TalkToSalesAuthedCta.propTypes = {
  hub: _propTypes.default.string.isRequired,
  location: _propTypes.default.string.isRequired,
  isPurple: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Mon307TalkToSalesAuthedCta;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/Mon307TalkToSalesAuthedCta.js
// module id = 177
// module chunks = 5 6